import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { BpmnEditorViewModel } from "./bpmnEditor/bpmnEditor-viewModel";
import { DataModelDesignerViewModel } from "./dataModelDesigner/dataModelDesigner-viewModel";
import  { ProcessDefinitionView } from "./processDefinition-view"
import { ProcessFormsViewModel } from "./processForms/processForms-viewModel";

export class ProcessDefinitionViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'جریان کار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.processes = ObservableArray.create<singleProcess>();
        
        let bpmnEditor = new BpmnEditorViewModel(this);
        let dataModelEditor = new DataModelDesignerViewModel(this);
        let forms = new ProcessFormsViewModel(this);
        this.processDefinitionParts = ObservableArray.create<IEditorPart>();
        this.processDefinitionParts.update(...[bpmnEditor,dataModelEditor,forms]);
        this.selectedDefinitionPart = bpmnEditor;

        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new ProcessDefinitionView();
    }
    public getTypeId(): string {
        return "VM-CB80AE60-49CD-48FB-A9C4-A1E615B7918C"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set processes(v: ObservableArray<singleProcess>) { this._processes = v; } public get processes(): ObservableArray<singleProcess> { return this._processes;} private _processes: ObservableArray<singleProcess>;
    public set selectedProcess(v: singleProcess) { 
        this._selectedProcess = v; 
        this.selectedDefinitionPart.loadByProcessId(v.id);
    } public get selectedProcess(): singleProcess { return this._selectedProcess;} private _selectedProcess: singleProcess;
    public set newProcessName(v: string) { this._newProcessName = v; } public get newProcessName(): string { return this._newProcessName;} private _newProcessName: string;
    
    public set processDefinitionParts(v: ObservableArray<IEditorPart>) { this._processDefinitionParts = v; } public get processDefinitionParts(): ObservableArray<IEditorPart> { return this._processDefinitionParts;} private _processDefinitionParts: ObservableArray<IEditorPart>;
    public set selectedDefinitionPart(v: IEditorPart) { 
        this._selectedDefinitionPart = v; 
        if(this.selectedProcess)
            this.selectedDefinitionPart.loadByProcessId(this.selectedProcess.id);
    
    } public get selectedDefinitionPart(): IEditorPart { return this._selectedDefinitionPart;} private _selectedDefinitionPart: IEditorPart;
    
    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetAllProcesses',{});
            this.processes.update(...result.Processes.map((x,i)=>{
                let r = new singleProcess(this);
                r.id = x.Id;
                r.index = i+1;
                r.name = x.Name;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async createNewProcess(){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/BpmsRawDataServices/CreateProcess',{
                Name:this.newProcessName
            });
            this.messageBoxConfirmSuccess('جریان کار با موفقیت ایجاد شد','ثبت');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}


export class singleProcess extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
}

export interface IEditorPart{
    loadByProcessId(processId:string);
    get title():string;set title(v:string);
} 